import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { resolveAppMountBase } from './lib/mountBase'
import { registerServiceWorker } from './lib/registerServiceWorker'
import './index.css'

const routerBase = resolveAppMountBase(typeof window !== 'undefined' ? window.location.pathname : '/')

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter basename={routerBase || undefined}>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)

// Mounted builds register the SW inline before the <base> tag is injected
// (Chrome throws InvalidStateError if a <base> with a different href is present
// at register-time). The dashboard itself runs without a <base>, so register here.
if (!document.querySelector('base[data-cc-mount-base]')) {
  registerServiceWorker()
}
